import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, tap } from 'rxjs/operators';
import {
  CollectDnaButtonClicked,
  LoadBlendStateSucceeded,
  LoadBlendStateErrored,
  ProjectCollectDnaDialogOpened,
} from './customer-dp.actions';
import { CustomerDPService } from 'src/app/store/customer-dp/customer-dp.service';
import { CustomerDPApiError, CustomerDPApiErrorTypes } from './customer-dp.errors';
import { CollectDnaDialogComponent } from 'src/app/shared/dialogs/collect-dna-dialog/collect-dna-dialog.component';
import { getRequestedDna } from './customer-dp.selectors';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { DialogEffectCreatorService } from 'src/app/shared/services/effect-creators/dialog-effect-creator.service';

@Injectable()
export class CustomerDpEffects {
  getBlendState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CollectDnaButtonClicked),
      switchMap(({ dpId }) =>
        this.customerDPService.getBlendState(dpId).pipe(
          map((blendState) => LoadBlendStateSucceeded({ blendState })),
          catchError((err) =>
            of(
              LoadBlendStateErrored({
                error: new CustomerDPApiError(
                  CustomerDPApiErrorTypes.LoadBlendStateError,
                  err.error.error,
                ),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  openCollectDnaDialog$ = this.dialogEffectCreator.createEffect({
    initiatingActions: [LoadBlendStateSucceeded],
    openedAction: ProjectCollectDnaDialogOpened,
    component: CollectDnaDialogComponent,
    data: {
      selector: getRequestedDna,
    },
  });

  trackCollectDialogOpen$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectCollectDnaDialogOpened),
        tap(() =>
          this.analytics.track({
            context: 'projectForm',
            object: 'CollectDnaDialog',
            action: 'opened',
          }),
        ),
      ),
    { dispatch: false },
  );

  trackCollectDnaError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoadBlendStateErrored),
        tap(() =>
          this.analytics.track({
            context: 'projectForm',
            object: 'CollectDnaDialog',
            action: 'errored',
          }),
        ),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private customerDPService: CustomerDPService,
    private analytics: AnalyticsService,
    private dialogEffectCreator: DialogEffectCreatorService,
  ) {}
}
